import React from 'react';

const WelcomeSection = () => {
  const welcomeData = [
    {
      imgSrc: "images/home8-images/box1-icon.png",
      title: "Aluminium Glass Window",
      description: "Enhance the elegance of your space with our premium aluminium glass windows. Durable, stylish, and low-maintenance, they are the perfect blend of functionality and aesthetics."
    },
    {
      imgSrc: "images/home8-images/box2-icon.png",
      title: "Aluminium Mosquito Net",
      description: "Keep your loved ones safe from insects while ensuring proper ventilation. Our aluminium mosquito nets are sturdy, lightweight, and designed for seamless integration with your windows."
    },
    {
      imgSrc: "images/home8-images/box3-icon.png",
      title: "Soundproof Glass Window",
      description: "Experience the peace you deserve with our soundproof glass windows. Engineered to reduce noise pollution, these windows create a tranquil environment for homes and offices."
    }
  ];
  

  return (
    // hm8WelcomeStrip
    <section className="">
      <div className="container">
        <div className="row">
          {welcomeData.map((item, index) => (
            <div key={index} className="col-md-4 col-sm-4 col-xs-12">
              <div className={`hm8Welcone${index === 0 ? 'Left' : index === 1 ? 'Center' : 'Right'}`}>
                <img src={item.imgSrc} className="img-responsive" alt="icon" />
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
